import { ResponseSalesInfo } from 'common-modules/general/API/main/types';
import dayjs from 'dayjs';

interface Props {
  salesInfo: ResponseSalesInfo | null;
}

const ComplexSection = ({ salesInfo }: Props) => {
  return (
    <div id="info" className="info">
      <h3>단지 정보</h3>
      <div className="column-group">
        <div className="column">
          <div className="apt-info">
            <p className="tit">위치</p>
            <p className="txt">
              {/* <span className="address">{salesInfo?.addrBizLnd}</span> */}
              <span className="address">광주광역시 남구 봉선동 1143-36번지 일원</span>
            </p>
          </div>
        </div>
        <div className="column">
          <div className="apt-info">
            <p className="tit">대지면적</p>
            <p className="txt">
              <span className="address">{salesInfo?.infoGrndArea}</span>
            </p>
          </div>
        </div>
        <div className="column">
          <div className="apt-info">
            <p className="tit">규모</p>
            <p className="txt">
              <span className="address">{salesInfo?.infoCstScl}</span>
            </p>
          </div>
        </div>
        <div className="column">
          <div className="apt-info">
            <p className="tit">총 세대 수</p>
            <p className="txt">
              <span className="address">{salesInfo?.cntsNwbdHosh}</span>
            </p>
          </div>
        </div>
      </div>
      <div className="column-group">
        <div className="column">
          <div className="apt-info">
            <p className="tit">주차대수</p>
            <p className="txt">
              {/* <span className="address">{salesInfo?.infoPklt}</span> */}
              <span className="address">총 717대(공동주택 705대 / 근생 12대)</span>
            </p>
          </div>
        </div>
        <div className="column">
          <div className="apt-info">
            <p className="tit">입주예정</p>
            <p className="txt">
              {/* <span className="address">
                {salesInfo?.ipjuDate ? dayjs(salesInfo?.ipjuDate, 'YYYY년 MM월').format('YYYY년 MM월 예정') : '미정'}
              </span> */}
               <span className="address">
               2024년 10월
                </span>
            </p>
          </div>
        </div>
        <div className="column">
          <div className="apt-info">
            <p className="tit">주택전시관 오픈 일정</p>
            <p className="txt">
              {/* <span className="address">
                {salesInfo?.ipjuExhibDate ? dayjs(salesInfo?.ipjuExhibDate, 'YYYY년 MM월').format('YYYY년 MM월 예정') : '미정'}
                </span> */}
                <span className="address">
                2023년 03월 31일
                </span>
            </p>
          </div>
        </div>
        <div className="column"></div>
      </div>
      <div className="caution-text">
        * 상기 분양 계획은 변경, 지연 또는 취소될 수 있습니다.
      </div>
    </div>
  );
};

export default ComplexSection;
